import Papa from "papaparse";

export function convertToCSV(arr: any[]) {
    const csv = Papa.unparse(arr);
    return csv;
}